"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchHomeDeliveryOptionsPath = exports.searchHomeDeliveryOptions = void 0;
const result_lib_1 = require("@invivodf/result-lib");
const utils_1 = require("../../../utils");
const searchHomeDeliveryOptions = (client) => async ({ checkoutId, consignmentId, addressId, logisticOfferId }) => {
    try {
        const response = await client.post((0, exports.searchHomeDeliveryOptionsPath)(checkoutId, consignmentId), {
            addressId,
            logisticOfferId
        });
        return result_lib_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            return result_lib_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.searchHomeDeliveryOptions = searchHomeDeliveryOptions;
const searchHomeDeliveryOptionsPath = (checkoutId, consignmentId) => `/v2/bff/appro/checkouts/${checkoutId}/consignments/${consignmentId}/home-delivery-options/search`;
exports.searchHomeDeliveryOptionsPath = searchHomeDeliveryOptionsPath;
